import { Protocol } from '../../Protocol';

export class ThirdPartyAccountProtocol {
  public static readonly SEARCH_ACCOUNT: string = `${Protocol.YATUNG_AUTH}CA025`;
  public static readonly UPDATE_ACCOUNT: string = `${Protocol.YATUNG_AUTH}CA026`;
  public static readonly GET_ACCOUNT: string = `${Protocol.YATUNG_AUTH}CA046`;
  public static readonly CREATE_ACCOUNT: string = `${Protocol.YATUNG_AUTH}CA051`;
  // 與 AuthProtocol.GET_JWT 同一支API，但這裡只帶 account 用來替廠商重新產生金鑰
  public static readonly REGENERATE_TOKEN: string = `${Protocol.YATUNG_AUTH}CA060`;
  // 第三方廠商帳號與工廠的關聯 (GET/POST/PUT/DELETE)
  public static readonly ACCOUNT_FACTORY: string = `${Protocol.YATUNG_API_ROOT}/thirdparty-account-factory`;
  // 第三方廠商帳號的限制搜尋資料日期 (GET/POST/PUT)
  public static readonly ACCOUNT_SEARCH_LIMIT: string = `${Protocol.YATUNG_API_ROOT}/thirdparty-account`;
  // 第三方廠商帳號與API回傳資料欄位的關聯 (GET/POST/PUT/DELETE)
  public static readonly ACCOUNT_API_COLUMN: string = `${Protocol.YATUNG_API_ROOT}/thirdparty-account-api-column`;
  // /thirdparty 底下每支API回傳資料的全部欄位 (GET)
  public static readonly API_COLUMNS: string = `${Protocol.YATUNG_API_ROOT}/thirdparty-account-api-column/api-columns`;
}
